import { Bot } from 'lucide-react';
import type { ModuleSpec } from '../types';

export const chatbotsSpec: ModuleSpec = {
  id: 'chatbots',
  icon: Bot,
  i18n: {
    namespace: 'modules',
    titleKey: 'chatbots.title',
    descriptionKey: 'chatbots.description',
  },
  nav: {
    path: '/chatbots',
    group: 'build',
    order: 20,
  },
  meta: {
    status: 'active',
    description: 'AI-powered chatbot management',
  },
};
